import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import RichText from "@qlik/qlik/src/components/RichText";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";

/**
 * GlobalHQ component
 * @param {Object} data - The data for the GlobalHQ
 * @returns {JSX.Element} - The GlobalHQ component
 */
const GlobalHQ = ({ data }) => {
    const { customId, title, additionalConfiguration, cardItems = [], cardCollections = [] } = data ?? {};

    return (
        <section className={getSpacingClassName(additionalConfiguration)} id={customId}>
            <div className="container">
                <div id={customId} className="mb-14.25 scroll-mt-55" data-section>
                    <div className="flex items-center mb-8 lg:mb-15 gap-7.5">
                        {data.title && <h3 className="flex-none max-w-full break-words">{title}</h3>}
                        <div className="bg-stone w-full h-0.25" />
                    </div>
                    <div>
                        {/* Map through the card items and display each one */}
                        {cardItems?.map((card) => (
                            <div key={card.id} className={`${styles.globalHqCard} max-w-[212px]`}>
                                <div className="tag-3 text-ocean mb-5 text-sm">{card.subtitle}</div>
                                {card.title && <h5 className="mb-3.75">{card.title}</h5>}
                                {card.body && <RichText data={card} className="mb-7.5 whitespace-pre-wrap" />}
                                {/* Map through the cta items and display each one */}
                                {card.cta?.map((button) => (
                                    <div key={button.id}>
                                        <Cta key={button.id} data={button} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                    <div className="flex flex-col gap-10 md:gap-[71px]">
                        {/* Map through the card collections and display each one */}
                        {cardCollections?.map((item) => (
                            <div key={item.id}>
                                {item.title && <h3 className="mb-9.5">{item.title}</h3>}
                                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-15">
                                    {item.cardItems?.map((itemCard) => (
                                        <div key={itemCard.id} className="min-w-58.25">
                                            <div>
                                                <div className={styles.globalHqCard}>
                                                    <div className="tag-3 text-ocean mb-5 text-sm">
                                                        {itemCard.subtitle}
                                                    </div>
                                                    {itemCard.title && <h5 className="mb-3.75">{itemCard.title}</h5>}
                                                    {itemCard.body && (
                                                        <RichText
                                                            data={itemCard}
                                                            className="mb-7.5 whitespace-pre-wrap"
                                                        />
                                                    )}
                                                    {/* Map through the cta items in each card and display each one */}
                                                    {itemCard.cta?.map((button) => (
                                                        <div key={button.id}>
                                                            <Cta key={button.id} data={button} />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GlobalHQ;
